import setMomentDateObjZero from './setMomentDateObjZero.js'

// Get Monday of week
const getPeriodeStartDate = (momentDate) => {
    const momentDateZero = setMomentDateObjZero(momentDate.clone())
    return momentDateZero.isoWeekday(1)
}

export default getPeriodeStartDate